import isEqual from 'lodash/isEqual';
import { normalizeBoqRowTextFields } from './boqLineText';

const TRANSIENT_ROW_KEYS = ['edited'];
const NUMERIC_ROW_FIELDS = ['quantity', 'budget_rate', 'budget_total'];

const normalizeNumericField = (value) => {
  if (value === '' || value == null) return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : value;
};

export const normalizeBoqRowForCompare = (row) => {
  if (!row || typeof row !== 'object') return row;
  const next = normalizeBoqRowTextFields({ ...row });
  TRANSIENT_ROW_KEYS.forEach((key) => {
    delete next[key];
  });
  NUMERIC_ROW_FIELDS.forEach((field) => {
    if (field in next) {
      next[field] = normalizeNumericField(next[field]);
    }
  });
  return next;
};

export const areBoqRowsEqual = (left, right) =>
  isEqual(normalizeBoqRowForCompare(left), normalizeBoqRowForCompare(right));

export const hasBoqEntryChanges = (nextEntries, entries) => {
  if (!Array.isArray(nextEntries) || !Array.isArray(entries)) return false;
  return !isEqual(
    nextEntries.map(normalizeBoqRowForCompare),
    entries.map(normalizeBoqRowForCompare)
  );
};
